export default `
<b>1. GENERAL PROVISIONS</b>

This Personal Data Processing Policy is drafted in accordance with the requirements of the Law of the Kyrgyz Republic dated April 14, 2008, No. 52-g "On Personal Data" (hereinafter referred to as the "Personal Data Law") and defines the procedure for processing personal data and measures to ensure the security of personal data.

1.1. The Operator considers its highest priority and condition for conducting its activities to respect the rights and freedoms of individuals when processing their personal data, including the protection of privacy, personal, and family secrets.

1.2. This Operator’s Policy regarding the processing of personal data (hereinafter referred to as the "Policy") applies to all information that the Operator may obtain about visitors to the website https://rbxpier.me/.

<b>2. KEY TERMS USED IN THE POLICY</b>

2.1. Automated processing of personal data – processing of personal data using computer technology.

2.2. Blocking of personal data – temporary suspension of personal data processing (except in cases where processing is necessary to clarify personal data).

2.3. Website – a collection of graphical and informational materials, as well as computer programs and databases, ensuring their availability on the internet at the network address https://rbxpier.me/.

2.4. Personal data information system – a set of personal data contained in databases and information technologies and technical means ensuring their processing.

2.5. Depersonalization of personal data – actions resulting in the impossibility of determining, without additional information, the ownership of personal data by a specific User or other subject of personal data.

2.6. Processing of personal data – any action (operation) or set of actions (operations) performed with or without the use of automation tools on personal data, including collection, recording, systematization, accumulation, storage, clarification (updating, modification), retrieval, use, transfer (distribution, provision, access), depersonalization, blocking, deletion, or destruction of personal data.

2.7. Operator – a state body, municipal body, legal entity, or individual, independently or jointly with others organizing and/or processing personal data, as well as determining the purposes of personal data processing, the composition of personal data to be processed, and the actions (operations) performed with personal data.

2.8. Personal data – any information directly or indirectly related to a specific or identifiable User of the website https://rbxpier.me/.

2.9. Personal data permitted for dissemination – personal data to which an unlimited number of persons have access, granted by the subject of personal data by consenting to the processing of personal data permitted for dissemination in the manner prescribed by the Personal Data Law (hereinafter referred to as "personal data permitted for dissemination").

2.10. User – any visitor to the website https://rbxpier.me/.

2.11. Provision of personal data – actions aimed at disclosing personal data to a specific person or a specific group of persons.

2.12. Dissemination of personal data – any actions aimed at disclosing personal data to an indefinite group of persons (transfer of personal data) or making personal data available to an unlimited number of persons, including publishing personal data in the media, posting on information and telecommunication networks, or providing access to personal data in any other way.

2.13. Cross-border transfer of personal data – transfer of personal data to the territory of a foreign state to a foreign authority, foreign individual, or foreign legal entity.

2.14. Destruction of personal data – any actions resulting in the irreversible destruction of personal data with no possibility of further restoring the content of personal data in the personal data information system and/or the destruction of physical media containing personal data.

<b>3. KEY RIGHTS AND OBLIGATIONS OF THE OPERATOR</b>


3.1. The Operator has the right to:

- Receive from the subject of personal data reliable information and/or documents containing personal data;

- Continue processing personal data without the subject’s consent if grounds specified in the Personal Data Law exist;

- Independently determine the composition and list of measures necessary and sufficient to fulfill obligations under the Personal Data Law and related regulations, unless otherwise provided by the Personal Data Law or other laws.


3.2. The Operator is obliged to:

- Provide the subject of personal data, upon request, with information regarding the processing of their personal data;

- Organize the processing of personal data in accordance with the laws of the Kyrgyz Republic;

- Respond to requests and inquiries from personal data subjects and their legal representatives in accordance with the Personal Data Law;

- Provide the authorized body for the protection of personal data subjects’ rights with necessary information within 30 days of receiving a request;

- Publish or otherwise ensure unrestricted access to this Policy;

- Implement legal, organizational, and technical measures to protect personal data from unauthorized or accidental access, destruction, alteration, blocking, copying, provision, dissemination, or other unlawful actions;

- Cease the transfer (dissemination, provision, access) of personal data, stop processing, and destroy personal data in cases prescribed by the Personal Data Law;

- Fulfill other obligations under the Personal Data Law.

<b>4. KEY RIGHTS AND OBLIGATIONS OF PERSONAL DATA SUBJECTS</b>


4.1. Personal data subjects have the right to:

- Obtain information regarding the processing of their personal data, except in cases provided by law;

- Demand the Operator to clarify, block, or destroy their personal data if the data is incomplete, outdated, inaccurate, unlawfully obtained, or unnecessary for the stated processing purpose;

- Require prior consent for processing personal data for marketing purposes;

- Withdraw consent to the processing of personal data;

- Appeal unlawful actions or inaction of the Operator to the authorized body or in court;

- Exercise other rights granted by the laws of the Kyrgyz Republic.


4.2. Personal data subjects must:

- Provide the Operator with accurate personal data;

- Notify the Operator of updates or changes to their personal data.

4.3. Persons who provide the Operator with false information about themselves or another personal data subject without consent bear responsibility under the laws of the Kyrgyz Republic.

<b>5. PERSONAL DATA PROCESSED BY THE OPERATOR</b>

5.1. Email address.

5.2. The website also collects and processes anonymized visitor data (including "cookies") using internet statistics services (Yandex Metrica, Google Analytics, etc.).

5.3. The above data is collectively referred to as "Personal Data" in this Policy.

5.4. The Operator does not process special categories of personal data (e.g., race, ethnicity, political views, religious beliefs, intimate life).

5.5. Processing of special categories of personal data permitted for dissemination is allowed only if restrictions and conditions under the Personal Data Law are met.

5.6. The User’s consent for processing personal data permitted for dissemination is obtained separately from other consents.

5.6.1. The User provides consent directly to the Operator.

5.6.2. The Operator must publish processing conditions within three business days of receiving consent.

5.6.3. Dissemination of personal data permitted by the subject must cease upon the subject’s request.

5.6.4. Consent for processing personal data permitted for dissemination terminates upon the Operator’s receipt of the subject’s request.

<b>6. PRINCIPLES OF PERSONAL DATA PROCESSING</b>


6.1. Processing is lawful and fair.

6.2. Processing is limited to specific, predefined, and legitimate purposes.

6.3. Incompatible databases must not be combined.

6.4. Only relevant personal data is processed.

6.5. The scope of processed data corresponds to the stated purposes.

6.6. Accuracy and sufficiency of data are ensured; outdated or inaccurate data is corrected or deleted.

6.7. Storage duration does not exceed necessary purposes unless required by law.

<b>7. PURPOSES OF PERSONAL DATA PROCESSING</b>

7.1. Purposes include:

- Informing Users via email;


- Executing civil contracts.

7.2. The Operator may notify Users about new products, services, and promotions. Users can opt out by emailing EPIK582@gmail.com with "Unsubscribe from notifications."

7.3. Anonymized data is used to improve website quality.

<b>8. LEGAL BASIS FOR PROCESSING</b>

8.1. Legal grounds include:

- Operator’s statutory documents;

- Laws on personal data protection;

- User consent.

8.2. The Operator processes data submitted via forms on https://rbxpier.me/ or via email.

8.3. Anonymized data is processed if browser settings allow (cookies, JavaScript).

8.4. The subject voluntarily provides personal data.

<b>9. CONDITIONS FOR PROCESSING</b>


9.1. Processing requires the subject’s consent.

9.2. Processing is necessary for legal obligations or public interests.

9.3. Processing is required for judicial or executive proceedings.

9.4. Processing is necessary for contract performance.

9.5. Processing serves legitimate interests without violating rights.

9.6. Publicly available data is processed.

9.7. Mandatory disclosure under law is followed.

<b>10. PROCEDURES FOR COLLECTION, STORAGE, AND TRANSFER</b>

10.1. The Operator ensures data security.

10.2. Data is not shared with third parties unless required by law or with consent.

10.3. Users can update their data by emailing EPIK582@gmail.com ("Update personal data").

10.4. Processing duration aligns with purposes unless extended by law.

10.5. Third-party services (e.g., payment systems) handle data per their policies.

10.6. Restrictions on data dissemination do not apply to public interest cases.

10.7. Confidentiality is maintained.

10.8. Storage duration is limited to processing purposes.

10.9. Processing ceases upon purpose fulfillment, consent withdrawal, or unlawful processing.

<b>11. OPERATOR’S ACTIONS WITH PERSONAL DATA</b>

11.1. The Operator collects, records, systematizes, stores, updates, retrieves, uses, transfers, depersonalizes, blocks, deletes, and destroys data.
11.2. Automated processing may involve data transmission via networks.

<b>12. CROSS-BORDER DATA TRANSFER</b>

12.1. The Operator ensures foreign states provide adequate data protection.
12.2. Transfer to non-compliant states requires written consent or contract performance.

<b>13. CONFIDENTIALITY</b>

The Operator and authorized persons must not disclose data without consent unless required by law.

<b>14. FINAL PROVISIONS</b>

14.1. Users can request clarifications via EPIK582@gmail.com.

14.2. The Policy may be updated; the current version is available at https://rbxpier.me/.

14.3. The Policy remains effective until replaced.
`.split(new RegExp(/\s+\r?\n/))
